import { defineMessages } from 'react-intl';

const scope = 'question_answer';

export default defineMessages({
  youSaidAtTime: {
    id: `${scope}.you_said_at_time`,
    defaultMessage: 'You said at {time}',
  },
});
